import { pageId, pageJa, pageKo, pageTh, pageZh } from './page-others';

/** Landing page copy (Digital Dollars UI). Merged over base translations for every language. */
export const page = {
    en: {
        metaTitle: 'APC Plus — Digital Dollars for Everyday Life',
        metaDescription:
            'Use Digital Dollars to send Red Packets, shop gift cards and eSIMs, book travel, earn cashback, and manage one everyday balance with APC Plus.',
        tickerLabel: 'Recent activity (demo)',
        openMenu: 'Open menu',
        getStarted: 'Get started',
        navPackets: 'Red Packets',
        navShopTravel: 'Shop & travel',
        navRewards: 'Rewards',
        navSafety: 'Security',
        navMore: 'More',
        navRoadmap: 'Roadmap',
        ddGiftCards: 'Gift cards',
        ddGiftCardsDesc: 'Browse brands across popular markets',
        ddEsims: 'eSIMs',
        ddEsimsDesc: 'Mobile data for home and travel',
        ddTravel: 'Hotels & flights',
        ddTravelDesc: 'Book trips with Digital Dollars',
        ddCashback: 'Cashback',
        ddCashbackDesc: 'Earn on eligible purchases',
        ddCircles: 'Circles & group gifting',
        ddCirclesDesc: 'Share moments with friends and family',
        ddRwaStocks: 'RWA Stocks',
        ddRwaStocksDesc: 'Stock-linked assets are on the roadmap',
        ddSecurityReserves: 'Security & reserves',
        ddSecurityReservesDesc: 'Passkeys, wallet safety, reserves',
        ddRoadmapDesc: 'What comes next for APC Plus',
        heroEyebrow: 'APC Plus · The everyday Digital Dollars wallet',
        heroTitleLead: 'Digital Dollars',
        heroTitleLine2: 'for',
        heroTypePhrase: 'everyday life.',
        heroTypePhrases: ['everyday life.', 'everyone gift.', 'everything cashback.'],
        heroTitleAria:
            'Digital Dollars for everyday life, everyone gift, and everything cashback.',
        heroLedeHtml:
            'APC Plus turns supported deposits into <strong>Digital Dollars for everyday use</strong>. Shop gift cards and eSIMs, book travel, send Red Packets, earn cashback and manage everything from one balance.',
        heroSvcLabel: 'What you can do',
        svcGiftCards: 'Gift cards',
        svcEsims: 'eSIMs',
        svcTravel: 'Hotels & flights',
        createFreeAccount: 'Create free account',
        howItWorks: 'How it works',
        trustPasskey: 'Passkey sign-in',
        trustFees: 'Clear fees before withdrawal',
        trustReserved: '1 Digital Dollar = 1 USDT, fully reserved',
        heroStageLabel: 'APC Plus app preview',
        phoneBalLabel: 'Available Digital Dollars',
        phoneBalUnit: 'Digital Dollars',
        whatEyebrow: 'What is APC Plus?',
        whatTitle: 'Stablecoins, made',
        whatTitleAccent: 'useful every day.',
        whatLead:
            'Crypto dollars like USDT are fast and global, but hard to spend on real things. APC Plus turns them into Digital Dollars you can use for shopping, travel and gifts, with an app that feels like any other wallet.',
        pipe1Label: '1 · Top up',
        pipe1Title: 'Add money your way',
        pipe1Text: 'Pay with a card, or send USDT or USDC from any exchange or wallet on six networks.',
        pipe2Label: '2 · Hold Digital Dollars',
        pipe2Title: 'One stable balance',
        pipe2Text:
            '1 Digital Dollar always equals 1 USDT, backed by published reserves. Sign in with your face. No seed phrase, no gas.',
        pipe3Label: '3 · Use it',
        pipe3Title: 'Spend, send, earn',
        pipe3Text: 'Everything below runs on the same balance, with cashback on purchases.',
        launchTitle: 'One balance. Plenty of ways to use it.',
        launchLead: 'Shop, travel, send, earn and manage Digital Dollars from APC Plus.',
        tilePacketsDesc: 'Send Digital Dollars with a personal message.',
        tileOpen: 'Open →',
        tileShopDesc: 'Gift cards, vouchers, eSIMs, hotels and flights.',
        tileExplore: 'Explore →',
        tileCashbackTitle: 'Cashback & rewards',
        tileCashbackDesc: 'Earn on eligible purchases and promotions.',
        tileLearn: 'Learn more →',
        tileCirclesDesc: 'Celebrate together and contribute to shared gifts.',
        tileSeePackets: 'See Red Packets →',
        comingSoon: 'Coming soon',
        comingLater: 'Coming later',
        statPackets: 'Red Packets opened',
        statCountries: 'Countries with eSIM data',
        statBrands: 'Gift card and voucher brands',
        statNetworks: 'Networks for USDT and USDC top-ups',
        everydayEyebrow: 'Everyday utility',
        everydayTitle: 'From the everyday to the getaway.',
        everydayLead: 'Use Digital Dollars for things you already buy, at home and while travelling.',
        lifeGiftAlt: 'Friends sharing a digital gift at a cafe',
        lifeGiftEyebrow: 'Gifting & everyday shopping',
        lifeGiftTitle: 'Gift cards & vouchers',
        lifeGiftCta: 'Explore brands →',
        lifeEsimAlt: 'A male traveller activating mobile data at an airport',
        lifeEsimEyebrow: 'Stay connected',
        lifeEsimTitle: 'eSIMs for home and travel',
        lifeEsimCta: 'Browse eSIMs →',
        lifeTravelAlt: 'A traveller checking a hotel booking on her phone',
        lifeTravelEyebrow: 'Plan the next trip',
        lifeTravelTitle: 'Hotels & flights',
        lifeTravelCta: 'Explore travel →',
        marketEyebrow: 'Where you can use it',
        marketTitle: 'Brands across popular markets.',
        marketLead:
            'Browse gift cards and vouchers across Asia, Europe, the Americas, Africa and the Middle East.',
        marketGridLabel: 'Popular supplier catalogue markets, sorted alphabetically',
        marketNote:
            'Coverage reflects connected supplier catalogues and can vary by brand, product, provider and market.',
        mostLoved: 'Most loved',
        spotTitle: 'One link.',
        spotTitleAccent: 'Everyone opens.',
        spotLead:
            'Fill a Red Packet with Digital Dollars, choose lucky or equal split and drop it into any group chat. Unclaimed shares come back to you.',
        createRedPacket: 'Create a Red Packet',
        seeHowItWorks: 'See how it works',
        popularWeek: 'Popular this week',
        exploreAll: 'Explore all →',
        rewardsEyebrow: 'Cashback & rewards',
        rewardsTitle: 'A little back for what you already buy.',
        rewardsLead:
            'Eligible purchases and promotions can add Digital Dollars to your APC Plus balance. Use them on the next purchase, put them toward a trip, or send them in a Red Packet.',
        exploreOffers: 'Explore offers →',
        trustPrivyEyebrow: 'Powered by Privy',
        trustPrivyTitle: 'Wallet security built in',
        trustPrivyText:
            'Encrypted key shares and isolated signing protect your embedded wallet without asking you to manage a seed phrase.',
        trustPrivyLink: 'About Privy security →',
        trustAccessEyebrow: 'Passwordless access',
        trustAccessTitle: 'Sign in your way',
        trustAccessText: 'Use an email one-time code or a linked passkey for simple, secure access to APC Plus.',
        trustAccessLink: 'Open APC Plus →',
        trustControlEyebrow: 'You stay in control',
        trustControlTitle: 'Review before you send',
        trustControlText:
            'Check the destination, amount and applicable fee before confirming an external-wallet withdrawal with your passkey.',
        trustControlLink: 'View your wallet →',
        networksTitle: 'Top up with USDT or USDC on',
        roadmapHeadTitle: 'Coming next',
        roadmapHeadLead: 'What we are building now.',
        roadmapStockTitle: 'RWA Stock Purchasing',
        roadmapStockDesc: 'Discover supported stock-linked real-world assets.',
        roadmapGoldTitle: 'RWA Gold & Earn',
        roadmapGoldDesc: 'Explore gold-linked assets and earning experiences.',
        roadmapLinksTitle: 'Payment Links & Requests',
        roadmapLinksDesc: 'Request or send Digital Dollars by email, QR code or link.',
        advancedMarketsLink: 'Advanced markets ↓',
        advancedEyebrow: 'APC Plus Advanced',
        advancedMarketsTitle: 'Advanced Markets',
        advancedMarketsDesc: 'Prediction Markets and Perpetual Trading in their own area.',
        advancedTitle: 'Prediction Markets & Perpetual Trading',
        advancedLead:
            'A separate experience for people who want advanced markets, subject to eligibility and local requirements.',
        finalTitle: 'Your Digital Dollars,',
        finalTitleAccent: 'ready for more.',
        finalLead: 'Shop, travel, send and earn from one everyday balance.',
        storeAppleSmall: 'Coming soon on the',
        storeGoogleSmall: 'Coming soon on',
        footerBlurb: 'Send, shop, earn and manage Digital Dollars. Part of the APC One family of apps.',
        footerExplore: 'Explore',
        footerCashback: 'Cashback & rewards',
        footerSafety: 'Safety & security',
        footerOpenApp: 'Open web app',
        footerBrowse: 'Browse products',
        footerWallet: 'Wallet',
        footerAdvanced: 'Advanced',
        footerContact: 'Contact',
        footerLegalNote: 'Product availability varies by market. Roadmap items are subject to change.',
        trademark: 'APC Plus is a trademark of APC TECHNOLOGY SDB BHD.',
    },
    vi: {
        metaTitle: 'APC Plus — Digital Dollars cho cuộc sống hàng ngày',
        metaDescription:
            'Dùng Digital Dollars để gửi Red Packet, mua thẻ quà và eSIM, đặt du lịch, nhận hoàn tiền và quản lý một số dư hàng ngày với APC Plus.',
        tickerLabel: 'Hoạt động gần đây (demo)',
        openMenu: 'Mở menu',
        getStarted: 'Bắt đầu',
        navPackets: 'Red Packet',
        navShopTravel: 'Mua sắm & du lịch',
        navRewards: 'Phần thưởng',
        navSafety: 'Bảo mật',
        navMore: 'Thêm',
        navRoadmap: 'Lộ trình',
        ddGiftCards: 'Thẻ quà',
        ddGiftCardsDesc: 'Duyệt thương hiệu tại các thị trường phổ biến',
        ddEsims: 'eSIM',
        ddEsimsDesc: 'Dữ liệu di động tại nhà và khi đi du lịch',
        ddTravel: 'Khách sạn & chuyến bay',
        ddTravelDesc: 'Đặt chuyến đi bằng Digital Dollars',
        ddCashback: 'Hoàn tiền',
        ddCashbackDesc: 'Nhận thưởng trên giao dịch đủ điều kiện',
        ddCircles: 'Circles & quà nhóm',
        ddCirclesDesc: 'Chia sẻ khoảnh khắc với bạn bè và gia đình',
        ddRwaStocks: 'RWA cổ phiếu',
        ddRwaStocksDesc: 'Tài sản liên kết cổ phiếu đang trên lộ trình',
        ddSecurityReserves: 'Bảo mật & dự trữ',
        ddSecurityReservesDesc: 'Passkey, an toàn ví, dự trữ',
        ddRoadmapDesc: 'Điều gì tiếp theo cho APC Plus',
        heroEyebrow: 'APC Plus · Ví Digital Dollars hàng ngày',
        heroTitleLead: 'Digital Dollars',
        heroTitleLine2: 'cho',
        heroTypePhrase: 'cuộc sống hàng ngày.',
        heroTypePhrases: [
            'cuộc sống hàng ngày.',
            'quà tặng mọi người.',
            'hoàn tiền mọi thứ.',
        ],
        heroTitleAria:
            'Digital Dollars cho cuộc sống hàng ngày, quà tặng mọi người và hoàn tiền mọi thứ.',
        heroLedeHtml:
            'APC Plus biến khoản nạp được hỗ trợ thành <strong>Digital Dollars dùng mỗi ngày</strong>. Mua thẻ quà và eSIM, đặt du lịch, gửi Red Packet, nhận hoàn tiền và quản lý mọi thứ trong một số dư.',
        heroSvcLabel: 'Bạn có thể làm gì',
        svcGiftCards: 'Thẻ quà',
        svcEsims: 'eSIM',
        svcTravel: 'Khách sạn & chuyến bay',
        createFreeAccount: 'Tạo tài khoản miễn phí',
        howItWorks: 'Cách hoạt động',
        trustPasskey: 'Đăng nhập bằng passkey',
        trustFees: 'Phí rõ ràng trước khi rút',
        trustReserved: '1 Digital Dollar = 1 USDT, dự trữ đầy đủ',
        heroStageLabel: 'Xem trước ứng dụng APC Plus',
        phoneBalLabel: 'Digital Dollars khả dụng',
        phoneBalUnit: 'Digital Dollars',
        whatEyebrow: 'APC Plus là gì?',
        whatTitle: 'Stablecoin,',
        whatTitleAccent: 'hữu ích mỗi ngày.',
        whatLead:
            'USDT nhanh và toàn cầu nhưng khó chi tiêu thực tế. APC Plus biến chúng thành Digital Dollars để mua sắm, du lịch và tặng quà — như ví thông thường.',
        pipe1Label: '1 · Nạp tiền',
        pipe1Title: 'Nạp theo cách của bạn',
        pipe1Text: 'Thẻ hoặc gửi USDT/USDC từ sàn hoặc ví trên sáu mạng.',
        pipe2Label: '2 · Giữ Digital Dollars',
        pipe2Title: 'Một số dư ổn định',
        pipe2Text: '1 Digital Dollar luôn bằng 1 USDT, có dự trữ công bố. Đăng nhập bằng khuôn mặt. Không seed phrase, không gas.',
        pipe3Label: '3 · Sử dụng',
        pipe3Title: 'Chi, gửi, nhận thưởng',
        pipe3Text: 'Mọi tính năng bên dưới dùng chung một số dư, kèm hoàn tiền khi mua.',
        launchTitle: 'Một số dư. Nhiều cách dùng.',
        launchLead: 'Mua sắm, du lịch, gửi, nhận thưởng và quản lý Digital Dollars trên APC Plus.',
        tilePacketsDesc: 'Gửi Digital Dollars kèm lời nhắn cá nhân.',
        tileOpen: 'Mở →',
        tileShopDesc: 'Thẻ quà, voucher, eSIM, khách sạn và chuyến bay.',
        tileExplore: 'Khám phá →',
        tileCashbackTitle: 'Hoàn tiền & phần thưởng',
        tileCashbackDesc: 'Nhận thưởng trên giao dịch và khuyến mãi đủ điều kiện.',
        tileLearn: 'Tìm hiểu →',
        tileCirclesDesc: 'Cùng nhau tặng quà và đóng góp nhóm.',
        tileSeePackets: 'Xem Red Packet →',
        comingSoon: 'Sắp ra mắt',
        comingLater: 'Sau này',
        statPackets: 'Red Packet đã mở',
        statCountries: 'Quốc gia có eSIM',
        statBrands: 'Thương hiệu thẻ quà & voucher',
        statNetworks: 'Mạng nạp USDT và USDC',
        everydayEyebrow: 'Tiện ích hàng ngày',
        everydayTitle: 'Từ việc thường ngày đến chuyến đi.',
        everydayLead: 'Dùng Digital Dollars cho thứ bạn vẫn mua, ở nhà và khi đi du lịch.',
        lifeGiftAlt: 'Bạn bè chia sẻ quà kỹ thuật số tại quán cà phê',
        lifeGiftEyebrow: 'Tặng quà & mua sắm',
        lifeGiftTitle: 'Thẻ quà & voucher',
        lifeGiftCta: 'Khám phá thương hiệu →',
        lifeEsimAlt: 'Du khách kích hoạt dữ liệu tại sân bay',
        lifeEsimEyebrow: 'Luôn kết nối',
        lifeEsimTitle: 'eSIM tại nhà và khi đi',
        lifeEsimCta: 'Duyệt eSIM →',
        lifeTravelAlt: 'Du khách xem đặt phòng trên điện thoại',
        lifeTravelEyebrow: 'Lên kế hoạch chuyến đi',
        lifeTravelTitle: 'Khách sạn & chuyến bay',
        lifeTravelCta: 'Khám phá du lịch →',
        marketEyebrow: 'Nơi bạn có thể dùng',
        marketTitle: 'Thương hiệu tại các thị trường phổ biến.',
        marketLead: 'Duyệt thẻ quà và voucher tại châu Á, châu Âu, châu Mỹ, châu Phi và Trung Đông.',
        marketGridLabel: 'Thị trường catalogue nhà cung cấp, theo alphabet',
        marketNote: 'Phạm vi phụ thuộc catalogue kết nối và có thể khác theo thương hiệu, sản phẩm và khu vực.',
        mostLoved: 'Được yêu thích',
        spotTitle: 'Một liên kết.',
        spotTitleAccent: 'Ai cũng mở được.',
        spotLead:
            'Nạp Digital Dollars vào Red Packet, chọn chia may mắn hoặc đều, gửi vào nhóm chat. Phần chưa nhận trả lại bạn.',
        createRedPacket: 'Tạo Red Packet',
        seeHowItWorks: 'Xem cách hoạt động',
        popularWeek: 'Phổ biến tuần này',
        exploreAll: 'Xem tất cả →',
        rewardsEyebrow: 'Hoàn tiền & phần thưởng',
        rewardsTitle: 'Một chút hoàn lại cho thứ bạn vẫn mua.',
        rewardsLead:
            'Giao dịch và khuyến mãi đủ điều kiện có thể cộng Digital Dollars vào số dư APC Plus. Dùng cho lần mua sau, chuyến đi, hoặc gửi Red Packet.',
        exploreOffers: 'Khám phá ưu đãi →',
        trustPrivyEyebrow: 'Powered by Privy',
        trustPrivyTitle: 'Bảo mật ví tích hợp',
        trustPrivyText: 'Chia khóa mã hóa và ký tách biệt bảo vệ ví nhúng — không cần tự quản seed phrase.',
        trustPrivyLink: 'Về bảo mật Privy →',
        trustAccessEyebrow: 'Đăng nhập không mật khẩu',
        trustAccessTitle: 'Đăng nhập theo cách bạn chọn',
        trustAccessText: 'Mã email một lần hoặc passkey liên kết để vào APC Plus an toàn, đơn giản.',
        trustAccessLink: 'Mở APC Plus →',
        trustControlEyebrow: 'Bạn kiểm soát',
        trustControlTitle: 'Xem lại trước khi gửi',
        trustControlText: 'Kiểm tra đích, số tiền và phí trước khi xác nhận rút ví ngoài bằng passkey.',
        trustControlLink: 'Xem ví →',
        networksTitle: 'Nạp USDT hoặc USDC trên',
        roadmapHeadTitle: 'Sắp tới',
        roadmapHeadLead: 'Chúng tôi đang xây dựng.',
        roadmapStockTitle: 'Mua cổ phiếu RWA',
        roadmapStockDesc: 'Khám phá tài sản thực liên kết cổ phiếu được hỗ trợ.',
        roadmapGoldTitle: 'RWA Vàng & Earn',
        roadmapGoldDesc: 'Tài sản liên kết vàng và trải nghiệm kiếm lời.',
        roadmapLinksTitle: 'Link thanh toán & yêu cầu',
        roadmapLinksDesc: 'Gửi hoặc yêu cầu Digital Dollars qua email, QR hoặc link.',
        advancedMarketsLink: 'Thị trường nâng cao ↓',
        advancedEyebrow: 'APC Plus Nâng cao',
        advancedMarketsTitle: 'Thị trường nâng cao',
        advancedMarketsDesc: 'Thị trường dự đoán và giao dịch vĩnh cửu trong khu riêng.',
        advancedTitle: 'Thị trường dự đoán & Giao dịch vĩnh cửu',
        advancedLead: 'Trải nghiệm riêng cho thị trường nâng cao, tùy điều kiện và quy định địa phương.',
        finalTitle: 'Digital Dollars của bạn,',
        finalTitleAccent: 'sẵn sàng hơn.',
        finalLead: 'Mua sắm, du lịch, gửi và nhận thưởng từ một số dư hàng ngày.',
        storeAppleSmall: 'Sắp có trên',
        storeGoogleSmall: 'Sắp có trên',
        footerBlurb: 'Gửi, mua sắm, nhận thưởng và quản lý Digital Dollars. Một phần họ APC One.',
        footerExplore: 'Khám phá',
        footerCashback: 'Hoàn tiền & phần thưởng',
        footerSafety: 'An toàn & bảo mật',
        footerOpenApp: 'Mở web app',
        footerBrowse: 'Duyệt sản phẩm',
        footerWallet: 'Ví',
        footerAdvanced: 'Nâng cao',
        footerContact: 'Liên hệ',
        footerLegalNote: 'Tính khả dụng sản phẩm khác theo thị trường. Lộ trình có thể thay đổi.',
        trademark: 'APC Plus là nhãn hiệu của APC TECHNOLOGY SDB BHD.',
    },
    zh: pageZh,
    th: pageTh,
    ja: pageJa,
    ko: pageKo,
    id: pageId,
};
